module.exports = __webpack_public_path__ + "static/media/viber.2308e35b.svg";